import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

import { post } from '@network/api';

export const useRetryOvo = (
  referenceId?: string,
  onSuccess?: () => void
): UseMutationResult<unknown, unknown, void> => {
  const location = useLocation();

  return useMutation({
    mutationFn: async () => {
      const { id } = qs.parse(location.search, { ignoreQueryPrefix: true }) as {
        id?: string;
      };

      if (!id) throw new Error('Invoice ID is missing');

      return post(`/checkout/v1/payment/ovo/retry?invoice_number=${id}`, {
        reference_id: referenceId,
      });
    },
    onSuccess: () => {
      onSuccess?.();
    },
  });
};
